/* eslint-disable @typescript-eslint/no-explicit-any */
import { getInitialRandomNode, NODE_TYPE, setInitialRandomNode } from '@constants';
import { changeBeacon } from '@lib/beacon';
import { actions } from '@state/settings';
import { getStore } from '@state/store';

export const testNodes = async () => {
  const before = Date.now();
  const result = await fetch(`https://status.versum.xyz/api/rpc`);
  if (result.status === 200) {
    const { timestamp, nodes } = await result.json();

    return {
      response: Date.now() - before,
      timestamp,
      nodes,
    };
  }

  return {
    response: Date.now() - before,
    timestamp: Date.now(),
    nodes: [],
  };
};

export const testNodeHealth = async (callback = () => null) => {
  const store = getStore();
  const state = store?.getState();

  // if nodes are in auto, detect health and change it they have any issues
  if (state.settings.general.nodetype === NODE_TYPE.AUTO) {
    // 1: ping all factory nodes in one go
    const ping = await testNodes();
    let currentNode = ping.nodes.find((e: any) => `https://${e.node}` === state.settings.general.node);

    let curTry = 0;
    const maxTry = 10;

    // recursively
    const swapAndTestNode = () => {
      // change to new node
      setInitialRandomNode();
      const nextNode = getInitialRandomNode().value;

      // check node from request
      currentNode = ping.nodes.find((e: any) => `https://${e.node}` === nextNode);
      if ((!currentNode || currentNode.level < 0 || currentNode.level > 2) && curTry < maxTry) {
        curTry += 1;
        swapAndTestNode();
      }

      // if node is valid, save preferences?
      store?.dispatch({ type: actions.SETTINGS_CHANGE_NODE, payload: `https://${currentNode.node}` });
      changeBeacon(state.settings.general.network, `https://${currentNode.node}`);
    };

    const healthyNode = currentNode.level >= 0 && currentNode.level <= 2;
    if (!healthyNode) {
      swapAndTestNode();
    }
  }

  callback();
};
